import { FC, useMemo } from 'react'
import styled from '@emotion/styled'
import { BrandLogo } from 'src/components/insights/location-visits/stats/location-logo'
import { Colors, Shapes } from 'src/components/theme'
import { Typography } from '@mui/material'
import { FlexRow } from 'src/components/flex-containers'

const Container = styled.div<{ size?: number }>`
  display: flex;
  overflow: hidden;
  padding-left: ${(props) => (props.size ? props.size / 4 : 4)}px;
  & > div {
    border-radius: 50% !important;
    margin-left: ${(props) => (props.size ? -props.size / 4 : -4)}px;
    border: 1px solid ${Colors.neutral50} !important;
    background-color: ${Colors.bgWhite} !important;
    img {
      border-radius: 50% !important;
    }
  }
`
const CircleIcon = styled.div<{ size?: number }>`
  border-radius: 50% !important;
  margin-left: ${(props) => (props.size ? -props.size / 4 : -4)}px;
  border: 1px solid ${Colors.neutral50} !important;
  background-color: ${Colors.bgWhite} !important;
  overflow: hidden;
  img {
    border-radius: 50% !important;
  }
`

const Image = styled.img<{ size?: number }>`
  width: ${(props) => props.size || 16}px;
  height: ${(props) => props.size || 16}px;
  border-radius: 50%;
`

type CircleImagesProps = {
  size?: number
  showCount?: boolean
  imageUrls: string[]
  brandIds?: string[]
  icons?: React.ReactNode[]
}
export const CircleImages: FC<CircleImagesProps> = ({ size, showCount, imageUrls, brandIds, icons }) => {
  const count = useMemo(() => {
    return imageUrls.length + (brandIds?.length ?? 0)
  }, [imageUrls, brandIds])
  return (
    <FlexRow align="center" gap={Shapes.spacing[2]}>
      <Container size={size}>
        {icons?.map((icon, index) => (
          <CircleIcon key={index} size={size}>
            {icon}
          </CircleIcon>
        ))}
        {imageUrls.map((url, index) => (
          <Image src={url} size={size} style={{ zIndex: imageUrls.length - index }} />
        ))}
        {brandIds?.map((brandId, index) => (
          <BrandLogo key={brandId + index} brandId={brandId} size={size || 16} noBorder />
        ))}
      </Container>
      {showCount && count > 10 && (
        <Typography variant="text1" style={{ marginLeft: 4 }}>
          ({count})
        </Typography>
      )}
    </FlexRow>
  )
}
